import { ref, onMounted, onBeforeUnmount } from "vue"

export const setupKeyboard = () => {
  const isSpaceKeyPressing = ref(false)

  const onKeyDown = event => {
    switch (event.key) {
      case " ":
        if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") {
          event.preventDefault()
          isSpaceKeyPressing.value = true
        }
        break
      default:
        break
    }
  }

  const onKeyUp = event => {
    switch (event.key) {
      case " ":
        event.preventDefault()
        isSpaceKeyPressing.value = false
        break
      default:
        break
    }
  }

  onMounted(() => {
    document.addEventListener("keydown", onKeyDown)
    document.addEventListener("keyup", onKeyUp)
  })

  onBeforeUnmount(() => {
    document.removeEventListener("keydown", onKeyDown)
    document.removeEventListener("keyup", onKeyUp)
  })

  return {
    isSpaceKeyPressing
  }
}
